import React, { useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
import { useAuth } from '@/context/AuthContext';

interface LogoutConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const LogoutConfirmDialog = ({ open, onOpenChange }: LogoutConfirmDialogProps) => {
  const { logout } = useAuth();

  useEffect(() => {
    console.log("LogoutConfirmDialog render, open:", open);
  }, [open]);

  const handleLogout = () => {
    logout();
    onOpenChange(false);
  };

  // 确保在按ESC或点击背景时不会关闭对话框
  const handleOpenChange = (newOpen: boolean) => {
    // 如果是要关闭对话框，通过点击Confirm按钮关闭
    if (!newOpen && open) {
      onOpenChange(newOpen);
    } else {
      onOpenChange(newOpen);
    }
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="bg-black/80 border border-white/10 text-white p-6 max-w-sm mx-auto backdrop-blur-sm"
        onEscapeKeyDown={(e) => e.preventDefault()}
        onPointerDownOutside={(e) => e.preventDefault()}>
        <DialogHeader className="space-y-0 p-0">
          <DialogTitle className="sr-only">Log Out Confirmation</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col items-center justify-center gap-5">
          {/* 动画图标 */}
          <motion.div
            className="w-24 h-24 relative flex items-center justify-center"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
          >
            <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="20" y="16" width="40" height="64" rx="4" stroke="hsl(var(--anzir))" strokeWidth="4"/>
              <circle cx="50" cy="48" r="4" fill="hsl(var(--anzir))"/>
              <motion.path
                d="M56 48H88M88 48L76 36M88 48L76 60"
                stroke="hsl(var(--anzir))"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
                initial={{ pathLength: 0, opacity: 0 }}
                animate={{ pathLength: 1, opacity: 1 }}
                transition={{ duration: 0.8, delay: 0.5 }}
              />
            </svg>
          </motion.div>

          {/* 标题 */}
          <motion.h2
            className="text-2xl font-bold text-center text-anzir"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            Log Out?
          </motion.h2>

          {/* 描述文本 */}
          <motion.p
            className="text-center text-gray-300 mb-4"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.4 }}
          >
            Look forward to the return of the adventurers!
          </motion.p>

          {/* 按钮 */}
          <motion.div
            className="w-full"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.5 }}
          >
            <Button
              className="w-full bg-anzir hover:bg-anzir/90 text-white"
              onClick={handleLogout}
            >
              Confirm
            </Button>
          </motion.div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default LogoutConfirmDialog;
